import Character from "../character/Character";
import GridTile from "../grid/GridTile";
import Vector from "../math/Vector";
import SpriteAnimation from "../sprite/SpriteAnimation";
import Effect from "./Effect";

/**
 * @abstract
 */
export default class EffectCreator {
    constructor() {        
    }

    /**
     * @abstract
     * @param {Character} effectOwner 
     * @param {Vector} effectPosition 
     * @returns {Effect}
     */
    createEffect(effectOwner, effectPosition) {
        return null;
    }

    /**
     * @abstract
     * @param {Character} effectOwner 
     * @param {GridTile} tile
     * @returns {Effect}
     */
    createEffectAtTile(effectOwner, tile) {
        return null;
    }


    /**
     * @abstract
     * @param {Character} effectOwner 
     * @param {Vector} position The origin position (top left)
     * @returns {Effect}
     */
    createEffectAtPosition(effectOwner, position) {
        return null;
    }

    /**
     * @abstract
     * @returns {SpriteAnimation}
     */
    getSpriteAnimation() {
        return null;
    }
}